import React from 'react'

function HandleUser() {
  return (
    <div>HandleUser</div>
  )
}

export default HandleUser